var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5481 8.59451L19.9882 0.125H18.2254L11.7623 7.47745L6.60399 0.125H0.653137L8.45521 11.2442L0.653137 20.125H2.41595L9.23698 12.3588L14.6856 20.125H20.6364L12.5481 8.59451ZM10.1329 11.3418L9.34122 10.2339L3.05165 1.42649H5.75969L10.8371 8.53701L11.6254 9.64492L18.2245 18.887H15.5165L10.1329 11.3418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweet);
export default __webpack_public_path__ + "static/media/tweet.211fa2c859f29f1820dbddcf258ea989.svg";
export { ForwardRef as ReactComponent };